import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './service-document-container.module.scss'

export function ServiceDocumentContainer({ ...props }) {
  return (
    <div
      {...props}
      className={classNames(Styles.pointContainer, props.className)}
    >
      <div className={Styles.pointContainer__header}>
        <p className="sans-serif">Service overview</p>
        <h2>Uniforceサービス説明資料</h2>
      </div>
      <ul>
        <li>決算開示業務における課題</li>
        <li>Uniforceがもたらす効果</li>
        <li>Uniforceの特徴</li>
        <li>サポート内容について</li>
        <li>セキュリティについて</li>
        <li>プランについて</li>
      </ul>
      <div className={Styles.picture}>
        <StaticImage src="../../images/contact_image_point.png" height={312} />
      </div>
    </div>
  )
}
